import { defineComponent, createBlock, openBlock, resolveDynamicComponent, normalizeClass, withCtx, createElementVNode, createElementBlock, createCommentVNode, renderSlot, Fragment, createVNode } from 'vue';
import _sfc_main$1 from './basler-components.es79.js';
/* empty css                       */

const _hoisted_1 = { class: "button-sorting__title" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ButtonSorting",
  props: {
    isSortable: { type: Boolean },
    sortingDirection: {},
    hideColumnLabel: { type: Boolean }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(_ctx.isSortable ? "button" : "span"), {
        type: _ctx.isSortable ? "button" : void 0,
        class: normalizeClass(["button-sorting", { "visually-hidden": _ctx.hideColumnLabel }])
      }, {
        default: withCtx(() => [
          createElementVNode("span", _hoisted_1, [
            renderSlot(_ctx.$slots, "default")
          ]),
          _ctx.isSortable ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createVNode(_sfc_main$1, { name: "sorting-asc" }),
            createVNode(_sfc_main$1, { name: "sorting-desc" })
          ], 64)) : createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["type", "class"]);
    };
  }
});

export { _sfc_main as default };
